import { ComponentType, SVGProps } from 'react';

import { IconButtonTypes } from 'components/IconButton/IconButton';

import { TranslationKey } from 'types/i18next';

import { CardActions, SidebarContentTypes } from 'constants/enums';

import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/closeSquare.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as SendIcon } from 'assets/icons/send.svg';

type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>;

export type CardMiniActionButtonUi = {
  icon: JSX.Element;
  tooltip: string;
  type: IconButtonTypes;
};

export type CardMiniActionButtonsConfigMap = Partial<
  Record<CardActions, CardMiniActionButtonUi>
>;

type CardMiniActionButtonDef = {
  action: CardActions;
  Icon: SvgIcon;
  tooltipKey: TranslationKey;
  type: IconButtonTypes;
};

type CardMiniActionButtonsGroup = {
  sidebarContentType: SidebarContentTypes;
  defs: CardMiniActionButtonDef[];
};

/**
 * Declarative icon/tooltip config for mini-card IconButtons, grouped by sidebar
 * type (mirrors {@link useCardActions} `base` actions shape).
 */
export const CARD_MINI_ACTION_BUTTON_DEFS: CardMiniActionButtonsGroup[] = [
  {
    sidebarContentType: SidebarContentTypes.ApplicationView,
    defs: [
      {
        action: CardActions.ApplicationScheduleInterview,
        Icon: CalendarIcon,
        tooltipKey: 'card.jobseeker.button.inviteForInterview',
        type: IconButtonTypes.Default
      },
      {
        action: CardActions.ApplicationSendOffer,
        Icon: SendIcon,
        tooltipKey: 'card.jobseeker.button.sendOffer',
        type: IconButtonTypes.Default
      },
      {
        action: CardActions.ApplicationReject,
        Icon: CloseIcon,
        tooltipKey: 'card.jobseeker.button.declineApplication',
        type: IconButtonTypes.Danger
      }
    ]
  },
  {
    sidebarContentType: SidebarContentTypes.JobseekerView,
    defs: [
      {
        action: CardActions.JobseekerInviteToJob,
        Icon: PlusIcon,
        tooltipKey: 'cardActions.label.inviteToJob',
        type: IconButtonTypes.Default
      }
    ]
  }
];

export const getCardMiniActionButtonsConfig = (
  t: (key: TranslationKey) => string
): CardMiniActionButtonsConfigMap => {
  const map: CardMiniActionButtonsConfigMap = {};

  for (const group of CARD_MINI_ACTION_BUTTON_DEFS) {
    for (const def of group.defs) {
      const Icon = def.Icon;
      map[def.action] = {
        icon: <Icon />,
        tooltip: t(def.tooltipKey),
        type: def.type
      };
    }
  }

  return map;
};
